module.exports = __webpack_public_path__ + "img/spriteimg.5cc47b8d.png";